module.exports = __webpack_public_path__ + "img/29_31.464d1353.png";